import mixpanel from "mixpanel-browser";
import type { AnalyticsProvider } from "common/analytics";
import { ga4Identify, ga4Register, ga4Reset, ga4SetUserProperties, ga4Track } from "./ga4";

// The ONLY new-path importer of mixpanel-browser. Implements the shared, platform-agnostic
// AnalyticsProvider contract for web; injected via setProvider() in init.ts.
// GA4 runs in `finally` so a Mixpanel failure neither skips GA nor changes what Mixpanel throws.
let mixpanelReady = false;

export const webMixpanelProvider: AnalyticsProvider = {
  init: (token, opts) => {
    mixpanel.init(token, opts);
    mixpanelReady = true;
  },
  track: (name, props) => {
    try {
      if (mixpanelReady) mixpanel.track(name, props);
    } finally {
      ga4Track(name, props);
    }
  },
  identify: (distinctId) => {
    try {
      if (mixpanelReady) mixpanel.identify(distinctId);
    } finally {
      ga4Identify(distinctId);
    }
  },
  reset: () => {
    try {
      if (mixpanelReady) mixpanel.reset();
    } finally {
      ga4Reset();
    }
  },
  register: (superProps) => {
    try {
      if (mixpanelReady) mixpanel.register(superProps);
    } finally {
      ga4Register(superProps);
    }
  },
  setUserProperties: (userProps) => {
    try {
      if (mixpanelReady) mixpanel.people.set(userProps);
    } finally {
      ga4SetUserProperties(userProps);
    }
  },
  // Mixpanel-only: identifyWithReset decides on reset from this, so GA must never influence it.
  getDistinctId: () => (mixpanelReady ? (mixpanel.get_distinct_id() ?? null) : null),
};
